import { Skeleton } from '@/components/ui/skeleton';

const DOW_HEADERS = 7;
const CALENDAR_CELLS = 42; // 6 weeks × 7 days, max possible

export function MonthViewSkeleton() {
  return (
    <div className="grid gap-4 xl:grid-cols-[1fr_360px]">
      {/* Left: full calendar */}
      <div className="overflow-hidden rounded-lg border bg-card shadow-sm">
        <div className="grid grid-cols-7 border-b bg-muted/40">
          {Array.from({ length: DOW_HEADERS }).map((_, i) => (
            <div key={i} className="border-l px-2 py-2.5 text-center first:border-l-0">
              <Skeleton className="mx-auto h-3 w-8" />
            </div>
          ))}
        </div>
        <div className="grid auto-rows-[110px] grid-cols-7">
          {Array.from({ length: CALENDAR_CELLS }).map((_, i) => (
            <div
              key={i}
              className="flex flex-col gap-1 border-l border-t p-2 first:border-l-0 [&:nth-child(7n+1)]:border-l-0"
            >
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-3 w-12" />
            </div>
          ))}
        </div>
      </div>

      {/* Right: day detail + projects this month */}
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-3 rounded-lg border bg-card p-4 shadow-sm">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-2 h-[18px] w-full rounded-full" />
          <div className="flex flex-wrap gap-x-4 gap-y-2 pt-1">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="flex flex-col gap-2 pt-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-12 w-full rounded-md" />
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 rounded-lg border bg-card p-4 shadow-sm">
          <Skeleton className="h-4 w-32" />
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-1">
              <Skeleton className="h-3.5 w-full" />
              <Skeleton className="h-1 w-full" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
